/**
 * Warning panel — amber-600 stripe + TriangleAlert icon. Schema mirrors
 * the rest of the named-panel set; visual identity comes from
 * NAMED_PANELS. Note the -600 shade on light theme — amber-500 fails
 * the 3:1 contrast bar on white per ADR-016.
 */

import { buildNamedPanelView } from './NamedPanelView'
import { buildPanelExtension } from './panel-extension-factory'
import { NAMED_PANELS } from './panel-kinds'

const spec = NAMED_PANELS.find((p) => p.kind === 'warning')
if (!spec) throw new Error('NAMED_PANELS missing warning kind — registry shape changed')

export const WarningPanel = buildPanelExtension({
  name: spec.nodeName,
  dataBlockType: spec.dataBlockType,
  view: buildNamedPanelView(spec),
})
